import {useSelector} from 'react-redux';

import {isNotNil} from 'ramda';

import {useGetTireOrderQuery} from '@dms/api/core';
import {selectSaleVehicle} from '@dms/api/vehicle';
import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';
import {Section} from '@dms/shared';
import {VehicleContentDetails, VehicleData, VehicleFeatures} from '@dms/vehicle-detail';

import {composePath} from 'shared/web';

import {useTiresInventoryUrl} from '../../hooks/useTiresInventoryUrl';

export function Vehicle() {
  const {orderId} = useTiresInventoryUrl();

  const {data: tireOrder} = useGetTireOrderQuery({orderId});

  const {data: saleVehicle} = useSelector(selectSaleVehicle(tireOrder?.vehicleId ?? ''));

  const isSaleVehicle = isNotNil(saleVehicle);

  return (
    <Section
      data-testid={testIds.tiresInventory.tireOrderDetail('vehicle')}
      tabs={
        tireOrder && tireOrder.vehicleId
          ? [
              {
                queryId: 'basicInformation',
                title: i18n.t('general.labels.basicInformation'),
                content: (
                  <VehicleContentDetails
                    isSaleVehicle={isSaleVehicle}
                    vehicleId={tireOrder.vehicleId}
                  />
                ),
              },
              {
                queryId: 'vehicleData',
                title: i18n.t('entity.vehicle.labels.vehicleData'),
                content: (
                  <VehicleData isSaleVehicle={isSaleVehicle} vehicleId={tireOrder.vehicleId} />
                ),
              },
              {
                queryId: 'features',
                title: i18n.t('entity.vehicle.labels.features'),
                content: <VehicleFeatures vehicleId={tireOrder.vehicleId} />,
              },
            ]
          : undefined
      }
      actions={
        tireOrder && tireOrder.vehicleId
          ? [
              {
                type: 'button',

                variant: 'outlined',
                leftIcon: 'action/launch',
                title: i18n.t('entity.vehicle.labels.vehicleDetails'),

                onClick: () =>
                  window.open(
                    composePath(vehiclesRoutes.detail, {params: {id: tireOrder.vehicleId}}),
                    '_blank',
                    'noopener,noreferrer'
                  ),
              },
            ]
          : undefined
      }
    />
  );
}
